const languages = {
    English: ["English (US)", "English (UK)", "English (Canada)"],
    Español: [
        "Español (México) [Spanish (Mexico)]",
        "Español (España) [Spanish (Spain)]",
        "Español (Colombia) [Spanish (Colombia)]",
        "Español (Argentina) [Spanish (Argentina)]",
        "Español (Chile) [Spanish (Chile)]",
        "Español (Perú) [Spanish (Peru)]",
        "Español (Cuba) [Spanish (Cuba)]",
        "Español (Puerto Rico) [Spanish (Puerto Rico)]",
    ],
    中文: [
        "普通话 (Mandarin) [Mandarin]",
        "廣東話 (Cantonese) [Cantonese]",
        "吴语 (Wu) [Wu]",
    ],
    हिन्दी: [
        "हिन्दी (भारत) [Hindi (India)]",
        "हिन्दी (फिजी) [Hindi (Fiji)]",
        "हिन्दी (मॉरिशस) [Hindi (Mauritius)]",
    ],
    العربية: [
        "العربية (الفصحى) [Arabic (Modern Standard)]",
        "العربية (المصرية) [Arabic (Egyptian)]",
        "العربية (الخليجية) [Arabic (Gulf)]",
        "العربية (الشامية) [Arabic (Levantine)]",
    ],
    Português: [
        "Português (Brasil) [Portuguese (Brazil)]",
        "Português (Portugal) [Portuguese (Portugal)]",
        "Português (Angola) [Portuguese (Angola)]",
    ],
    Русский: [
        "Русский (Россия) [Russian (Russia)]",
        "Русский (Беларусь) [Russian (Belarus)]",
        "Русский (Казахстан) [Russian (Kazakhstan)]",
    ],
    Français: [
        "Français (France) [French (France)]",
        "Français (Canada) [French (Canada)]",
        "Français (Haiti) [French (Haiti)]",
        "Français (Belgique) [French (Belgium)]",
    ],
    日本語: [
        "日本語 (標準語) [Japanese (Standard)]",
        "日本語 (関西弁) [Japanese (Kansai)]",
        "日本語 (九州弁) [Japanese (Kyushu)]",
    ],
    Caribbean: [
        "Kreyòl Ayisyen (Haitian Creole) [Haitian Creole]",
        "Papiamento (Aruba, Curaçao, Bonaire) [Papiamento]",
        "Jamaican Patois (Jamaica) [Jamaican Patois]",
        "Bajan Creole (Barbados) [Bajan Creole]",
        "Lesser Antillean Creole French (Saint Lucia, Dominica) [French Creole]",
    ],
    မြန်မာဘာသာ: [
        "မြန်မာစကား (Standard Burmese) [Burmese (Standard)]",
        "ရခိုင်စကား (Rakhine) [Burmese (Rakhine)]",
        "ရှမ်းစကား (Shan) [Burmese (Shan)]",
    ],
};

export default languages;
